<template>
    <div :class="`grupo_campos ${type==='select' ? 'tipo_drop f1-chevron-down' : 'tipo_text'} ${classes}`"
         v-custom-validations="field.$error">
        <label v-if="label" :for="id">{{label}}</label>
        <input :id="id" v-if="type==='text' || type==='password' || type==='tel'"
               :type="type"
               :maxlength="length"
               ref="input"
               v-on:keypress.enter="onPressEnter"
               v-model.trim="field.$model"
               :disabled="disabled"
               autocomplete="off"
               :placeholder="placeholder"/>
        <select v-model="field.$model" :id="id" v-if="type==='select'" :disabled="disabled">
            <option :value="null">Elegir</option>
            <option v-for="item in items" :value="useIdOnSelect ? ( item.id ? item.id : item._id ) : item.key">
                {{ useLabelOnSelect ? item.label : item.value }}
            </option>
        </select>
        <textarea-autosize :id="id" v-if="type==='textarea'"
                           :type="type"
                           :maxlength="length"
                           ref="input"
                           v-on:keypress.enter="onPressEnter"
                           v-model.trim="field.$model"
                           :disabled="disabled"
                           :min-height="30"
                           :max-height="250"
                           autocomplete="off"
                           :rows="rows"
                           :placeholder="placeholder"></textarea-autosize>
        <span v-if="field.$error && field.required !== undefined && !field.required"><i class="f1-cerrar"></i>Campo requerido</span>
        <span v-if="field.$error && field.email !== undefined && !field.email"><i class="f1-cerrar"></i>Correo electrónico incorrecto</span>
        <span v-if="field.$error && field.mobilePhone !== undefined && !field.mobilePhone"><i class="f1-cerrar"></i>Celular incorrecto</span>
        <span v-if="field.$error && field.idCard !== undefined && !field.idCard"><i class="f1-cerrar"></i>DNI incorrecto</span>
        <span v-if="field.$error && field.minLength !== undefined && !field.minLength"><i class="f1-cerrar"></i>Debe tener una longitud mínima
            de {{field.$params.minLength.min}} caracteres</span>
        <span v-if="field.$error && field.exactLength !== undefined && !field.exactLength"><i class="f1-cerrar"></i>Debe ingresar {{field.$params.exactLength.value}} dígitos</span>
        <span v-if="field.$error && field.decimal !== undefined && !field.decimal"><i class="f1-cerrar"></i>Debe ingresar un monto válido</span>
        <span v-if="field.$error && field.integer !== undefined && !field.integer"><i class="f1-cerrar"></i>Debe ingresar un valor entero</span>
        <span v-if="field.$error && field.alphaNum !== undefined && !field.alphaNum"><i class="f1-cerrar"></i>Debe ingresar un valor alfanumérico</span>
        <span v-if="field.$error && field.minValue !== undefined && !field.minValue"><i class="f1-cerrar"></i>El mínimo valor permitido es {{field.$params.minValue.min}}</span>
        <span v-if="field.$error && field.numeric !== undefined && !field.numeric"><i class="f1-cerrar"></i>Debe ingresar un número válido</span>
    </div>
</template>

<script>

    export default {
        components: {},
        props: {
            label: {
                type: String,
                required: false,
            },
            classes: {
                type: String,
                required: false,
                default: 'text'
            },
            id: {
                type: String,
                default: 'text'
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            field: Object,
            focus: Boolean,
            onPressEnter: {
                type: Function,
                default: () => {
                }
            },
            length: {
                type: String
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            init: {
                type: Boolean,
                required: false,
                default: true
            },
            rows: {
                required: false,
                default: false
            },
            items: Array,
            useLabelOnSelect: {
                type: Boolean,
                required: false,
                default: false
            },
            useIdOnSelect: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        mounted() {
            if (this.focus) {
                this.$refs.input.focus();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/CInput.vue